import React from "react";

export const Header = () => {
  return (
    <center>
      <h1>🔥 Sports Teams 🔥</h1>
    </center>
  );
};
